import React from 'react';
import LegalLayout, { LegalSection } from './LegalLayout';

const EMAIL = 'aryanshivhare004@gmail.com';

const PrivacyPolicy = () => {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated="June 2026" canonical="https://aryanshivhare.com/privacy-policy" description="Privacy Policy for aryanshivhare.com — how we collect, use, and protect your data, including cookies and Google AdSense.">
      <p>
        This Privacy Policy describes how Aryan Shivhare ("we", "us", or "I") collects, uses, and
        protects your information when you visit aryanshivhare.com (the "Site"). By using the Site,
        you agree to the practices described in this policy.
      </p>

      <LegalSection heading="Information We Collect">
        <p>We may collect the following information:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong className="text-white">Contact information</strong> — when you submit the
            contact form, we collect your name, email address, subject, and message.
          </li>
          <li>
            <strong className="text-white">Newsletter subscriptions</strong> — when you subscribe,
            we collect your email address.
          </li>
          <li>
            <strong className="text-white">Usage data</strong> — like most websites, we may
            automatically collect anonymous data such as browser type, device, pages visited, and
            time spent, through cookies and analytics tools.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="How We Use Your Information">
        <ul className="list-disc pl-6 space-y-2">
          <li>To respond to your inquiries and provide requested services.</li>
          <li>To send newsletters and marketing updates (only if you subscribed).</li>
          <li>To improve the content, performance, and user experience of the Site.</li>
          <li>To comply with legal obligations.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Cookies">
        <p>
          The Site uses cookies to enhance your experience, analyze traffic, and serve relevant
          ads. Cookies are small text files stored on your device. You can disable cookies through
          your browser settings, though some features of the Site may not function properly as a
          result.
        </p>
      </LegalSection>

      <LegalSection heading="Google AdSense & Third-Party Advertising">
        <p>
          This Site uses Google AdSense to display advertisements. Google, as a third-party vendor,
          uses cookies to serve ads based on your prior visits to this and other websites.
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            Google's use of advertising cookies enables it and its partners to serve ads to you
            based on your visits to this Site and/or other sites on the Internet.
          </li>
          <li>
            You may opt out of personalized advertising by visiting{' '}
            <a
              href="https://www.google.com/settings/ads"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold underline underline-offset-4 hover:opacity-70"
            >
              Google Ads Settings
            </a>
            .
          </li>
          <li>
            For more information about how Google uses data, visit{' '}
            <a
              href="https://policies.google.com/technologies/partner-sites"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold underline underline-offset-4 hover:opacity-70"
            >
              Google's Privacy & Terms
            </a>
            .
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="Third-Party Links">
        <p>
          The Site may contain links to external websites. We are not responsible for the privacy
          practices or content of those third-party sites. We encourage you to review their privacy
          policies.
        </p>
      </LegalSection>

      <LegalSection heading="Data Security">
        <p>
          We take reasonable measures to protect your personal information. However, no method of
          transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
        </p>
      </LegalSection>

      <LegalSection heading="Your Rights">
        <p>
          Depending on your location (including under the EU GDPR), you may have the right to
          access, correct, or delete your personal data, or to withdraw consent at any time. To
          exercise these rights, contact us using the details below.
        </p>
      </LegalSection>

      <LegalSection heading="Children's Privacy">
        <p>
          This Site is not intended for children under 16, and we do not knowingly collect personal
          information from children.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. Any changes will be posted on this
          page with an updated "Last updated" date.
        </p>
      </LegalSection>

      <LegalSection heading="Contact Us">
        <p>
          If you have any questions about this Privacy Policy, contact us at{' '}
          <a href={`mailto:${EMAIL}`} className="text-gold underline underline-offset-4 hover:opacity-70">
            {EMAIL}
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
};

export default PrivacyPolicy;
